import GroupMember from './GroupMember';

export default GroupMember;